import DataMapping from "./DataMapping";

export default DataMapping;
